import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, LL_H_C } from '@nu-art/thunderstorm-frontend/index';
import './Editor_FindingViewSections.scss';
import { Q_SortableList } from '@app/hcs-frontend';
import { Editor_FindingViewSection } from '../Editor_FindingViewSection/Editor_FindingViewSection.js';
import { ICONS } from '@app/styles';
export class Editor_FindingViewSections extends ComponentSync {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable = nextProps.editable;
        state.editMode = nextProps.editMode;
        state.selectedSectionIndex ??= 0;
        return state;
    }
    // ######################## Render ########################
    render() {
        return _jsxs(LL_H_C, { className: 'editor__finding-view-sections', children: [this.renderSectionList(), this.renderSectionEditor()] });
    }
    renderSectionList = () => {
        const editable = this.state.editable;
        const sections = [...editable.item];
        return _jsx(Q_SortableList, { className: 'editor__finding-view-sections__list', disabled: !this.state.editMode, items: sections, itemRenderer: (section, index) => {
                const selected = index === this.state.selectedSectionIndex;
                return _jsxs(LL_H_C, { style: { justifyContent: 'space-between' }, className: selected ? 'selected' : undefined, onClick: () => {
                        if (selected)
                            return;
                        this.setState({ selectedSectionIndex: index });
                    }, children: [section?.label ?? 'N/A', this.state.editMode && _jsx(ICONS.bin.component, { onClick: () => {
                                editable.removeArrayItem(index);
                            } })] });
            }, onChange: async (sections) => {
                editable.updateItem(sections);
                await editable.save();
            } });
    };
    renderSectionEditor = () => {
        const editable = this.state.editable;
        if (!editable.item[this.state.selectedSectionIndex])
            return;
        const section = editable.editProp(this.state.selectedSectionIndex, {});
        return _jsx(Editor_FindingViewSection, { editable: section, editMode: this.state.editMode });
    };
}
//# sourceMappingURL=Editor_FindingViewSections.js.map